var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"rsFilterButton",attrs:{"type":"primary","icon":"fa fa-filter fa-fw","size":"sm"},on:{"click":_vm.handleClick}},[_vm._v("Filtrar")])
}
var staticRenderFns = []

export { render, staticRenderFns }